<template>
  <v-app-bar
    height="70"
    max-height="70"
    class="app-bar pl-2"
    :style="{ backgroundColor: background ? background : '#FFFFFF' }"
  >
    <ConfirmationDialog
      body="Are you sure you want to sign out?"
      title="Confirm sign out"
      yesText="Okay"
      noText="Cancel"
      :isOpen="isLoggingOut"
      @yes="logout"
      @no="isLoggingOut = false"
    />
    <div 
      v-if="isNACCMerchant" 
      class="app-bar__logo-naccc">
      <a href="https://www.catch.sg/" target="_top">
        <img
          :src="$vuetify.breakpoint.smAndDown ? require(`@/assets/NACCCandNHB-logo.webp`) : require(`@/assets/NACCCandNHB-logo-big.webp`)"
        />
      </a>
    </div>
    <div v-else class="app-bar__logo">
      <img 
        :src="require(`@/assets/nhb-logo2.webp`)" width="63" height="40" loading="lazy"
      />

    </div>
    <div class="d-flex align-center">
      <div class="flex-column app-bar__header" @click="isHomePage">
        <span class="text-caption header-text--text font-weight-bold">
          {{ GetCaption('APP_BAR_HEADER') }}
        </span>
        <h3 class="text-h3 header-text--text">
          {{ merchant === '62de6637e7d0250014e2dcbc' ? 'NHB Games' : shopName }}
        </h3>
      </div>
    </div>
    <v-spacer v-if="isCulturePassEnable && $vuetify.breakpoint.smAndDown"></v-spacer>
    <div 
      v-if="isCulturePassEnable" 
      class="app-bar__logo-cp">
      <a :href="REDIRECT_URL_CP" target="_top">
        <img
          :src="$vuetify.breakpoint.smAndDown ? require(`@/assets/culture-pass-logo.webp`) : require(`@/assets/culture-pass-logo.webp`)"
        />
      </a>
    </div>
    <v-spacer></v-spacer>
    <AuthMenu class="app-bar__button align-self-center" @openSidebarMenu="openSidebarMenu = true"/>
    <SideBarMenu :open="openSidebarMenu" @close="openSidebarMenu = false"/>
    <div class="app-bar__text-container">
      <v-badge
        :content="totalItems"
        :value="!!totalItems"
        color="#5579C6"
        overlap
      >
        <router-link :to="getPath(`/cart`)">
          <div class="pt-1 pe-2">
            <v-img :src="require(`@/assets/icons/cart.webp`)" width="25px"/>
          </div>
        </router-link>
      </v-badge>
      <router-link v-if="!isCulturePassEnable && !isGuestLogin" :to="getPath(`/`)">
        <h1
          class="app-bar__text text-h4 pb-1"
          :style="`border-bottom: ${isBrowse ? '2px solid #123262' : 'none'}`"
        >
          Browse
        </h1>
      </router-link>
      <router-link :to="getPath(`/my-tickets`)" v-if="loggedIn && !isGuestLogin">
        <h1
          class="app-bar__text text-h4 pb-1"
          :style="`border-bottom: ${isMyTickets ? '2px solid #123262' : 'none'}`"
        >
          My Tickets
        </h1>
      </router-link>
      <router-link :to="getPath(`/profile`)" v-if="loggedIn && !isGuestLogin">
        <h1
          class="app-bar__text text-h4 pb-1"
          :style="`border-bottom: ${isProfile ? '2px solid #123262' : 'none'}`"
        >
          My Profile
        </h1>
      </router-link>
      <router-link :to="getPath(`/my-heritage`)" v-if="loggedIn && !isGuestLogin">
        <h1
          class="app-bar__text text-h4 pb-1"
          :style="`border-bottom: ${isHeritage ? '2px solid #123262' : 'none'}`"
        >
          My Past Activities
        </h1>
      </router-link>
      <div
        v-if="loggedIn && !isGuestLogin"
        class="app-bar__text text-h4 pb-1"
        @click="isLoggingOut = true"
      >
        Sign Out
      </div>
      <router-link v-else-if="!isCulturePassEnable && !isGuestLogin" :to="getPath(`/auth`)">
        <h1
          class="app-bar__text text-h4 pb-1"
          :style="`border-bottom: ${isSignIn ? '2px solid #123262' : 'none'}`"
        >
          My Account
        </h1>
      </router-link>
    </div>
  </v-app-bar>
</template>

<style lang="scss" scoped>

.app-bar {
  box-shadow: none !important;
  z-index: $app-bar-z-index !important;
  color: var(--v-primary-darken4);

  &__header {
    cursor: pointer;
  }

  &__logo, &__logo-naccc {
    display: flex;
    align-content: center;
    margin-right: 12px;
  }

  &__logo-naccc img {
    height: 80px;
  }

   &__logo-cp img {
    height: 80px;
    padding-top: 10px;
  }

  &__button::before {
    opacity: 0 !important;
  }

  &__text-container {
    display: flex;
    flex-direction: row;
  }

  &__text {
    margin-right: 12px;
    margin-left: 16px;
    color: var(--v-primary-darken4);
    cursor: pointer;
  }
}

.app-tabs {
  .v-tabs-bar {
    background-color: transparent !important;
  }
  &::v-deep .v-slide-group__prev {
    display: none !important;
  }

  &::v-deep .v-tab--active.v-tab:not(:focus)::before {
    opacity: 0 !important;
  }

  &::v-deep .v-tab {
    text-transform: none !important;
    font-weight: 400 !important;
    font-size: 14px !important;
    color: black !important;
    padding: 0 !important;
    margin-bottom: 8px;
    margin-right: 16px;
    margin-left: 16px;
    min-width: 0px !important;
  }

  &::v-deep .v-tab:not(.v-tab--active) {
    opacity: 0.5 !important;
  }
}

@media #{map-get($display-breakpoints, "sm-and-down")} {
  .app-bar {
    &__text-container {
      display: none !important;
    }
    &__logo {
      display: none !important;
    }
    &__logo-naccc img {
      height: 30px;
    }
    &__logo-cp img {
      height: 40px;
    }
  }
}

@media #{map-get($display-breakpoints, "md-and-up")} {
  .app-bar {
    padding: 1rem 0;
    height: 90px !important;
    &__logo, &__logo-naccc{
      margin-left: 60px;
    }

    &__logo-naccc img {
      height: 40px;
    }

    &__logo-cp img {
      margin-left: 60px;
      height: 40px;
      padding-top: 10px
    }

    &__text-container {
      margin-right: 60px;
    }

    &__button {
      display: none;
    }
  }
}
</style>

<script lang="ts">
import Vue from 'vue'
import Options from 'vue-class-component'
import { mapGetters } from 'vuex'
import { GetCaption } from '@/utils/util.language'
import { getPath } from '@/utils/general-utils'

import ConfirmationDialog from '@/components/ConfirmationDialog.vue'
import SideBarMenu from '@/components/SidebarMenu.vue'
import { AUTH_DISPATCH_LOGOUT, DELETE_CART } from '@/store/types'
import { REDIRECT_URL_CP } from '@/config/constants'

import AuthMenu from '@/components/AuthMenu.vue'
import { Prop } from 'vue-property-decorator'

@Options({
  components: {
    AuthMenu,
    ConfirmationDialog,
    SideBarMenu,
  },
  computed: {
    ...mapGetters([
      'shopName',
      'isNACCMerchant',
      'totalItems',
      'isCulturePassEnable',
      'isGuestLogin',
      'merchant',
    ])
  }
})
export default class AppAppBar extends Vue {
  GetCaption = GetCaption
  getPath = getPath
  showMenu = false
  isLoggingOut = false
  openSidebarMenu = false
  REDIRECT_URL_CP = REDIRECT_URL_CP
  isCulturePassEnable!: boolean
  isGuestLogin!: boolean
  merchant!: string

  @Prop(String) readonly background!: string

  get loggedIn(): string {
    return this.$store.state.auth.token
  }

  get isCart(): boolean {
    const params = this.$route.path.split('/')
    return params.includes('cart')
  }

  get isBrowse(): boolean {
    const params = this.$route.path.split('/')
    return params[params.length - 1] === '' || params.length === 4 || params.includes('ticket')
  }

  get isMyTickets(): boolean {
    const params = this.$route.path.split('/')
    return params.includes('my-tickets')
  }

  get isSignIn(): boolean {
    const params = this.$route.path.split('/')
    return params.includes('auth')
  }

  get isProfile(): boolean {
    const params = this.$route.path.split('/')
    return params.includes('profile')
  }

  get isHeritage(): boolean {
    const params = this.$route.path.split('/')
    return params.includes('my-heritage')  
  }

  async logout(): Promise<void> {
    this.$store.dispatch(DELETE_CART)
    this.$store.dispatch(AUTH_DISPATCH_LOGOUT)
    await this.$store.dispatch('resetCheckoutCart')
    this.isLoggingOut = false
    this.$router
      .push(getPath('/'))
      .catch((err) => err.message)
  }

  isHomePage(): void{
    if (this.isCulturePassEnable) {
      return
    }

    if(this.$route.name !== 'Home') {
      this.$router
        .push(getPath('/'))
        .catch((err) => err.message)
    }
  }
}
</script>
